import { Button, Flex, Typography, colors } from '@aloft/toolkit-sui';

import { dismissDefaultFiltersInfo } from '../FilterDrawer/defaultFiltersInfoToastStorage.ts';

export const DefaultFiltersInfoToast = ({
  orderID,
  propertyTypeLabel,
  proximityRequirementMiles,
  saleDateRequirementMonths,
  glaPercentage,
  siteSizePercentage,
  onDismiss,
}: {
  orderID: string;
  propertyTypeLabel?: string;
  proximityRequirementMiles?: number;
  saleDateRequirementMonths?: number;
  glaPercentage: number;
  siteSizePercentage: number;
  onDismiss: () => void;
}) => (
  <Flex
    position="absolute"
    top="16px"
    left="16px"
    zIndex={10}
    width="fit-content"
    maxWidth="420px"
    backgroundColor="alertInfoLight"
    borderColor="surfaceAccent1"
    borderWidth="1px"
    borderStyle="solid"
    borderRadius="8px"
    padding="8px 11px"
    alignItems="center"
    gap="9px"
    boxShadow="0px 0px 4px 0px rgba(0,0,0,0.04), 0px 4px 8px 0px rgba(0,0,0,0.08)"
  >
    <svg
      width={28}
      height={28}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
      fillRule="nonzero"
    >
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20Z"
        fill={colors.surfaceAccent1}
      />
      <path d="M9 9V15H11V9H9ZM9 5V7H11V5H9Z" fill={colors.textOffset} />
    </svg>
    <Flex flexDirection="column" gap="4px" minWidth={0}>
      <Typography variant="h4">Default Filters</Typography>
      <ul style={{ listStyleType: 'disc', paddingInlineStart: '18px', margin: 0 }}>
        {propertyTypeLabel && (
          <li>
            <Typography variant="body2">Property Type is set to {propertyTypeLabel}</Typography>
          </li>
        )}
        {proximityRequirementMiles !== undefined && (
          <li>
            <Typography variant="body2">
              Proximity (map) is set to {proximityRequirementMiles} mile radius from Subject
            </Typography>
          </li>
        )}
        {saleDateRequirementMonths !== undefined && (
          <li>
            <Typography variant="body2">
              Sale Date is set to the last {saleDateRequirementMonths} months from Effective Date
            </Typography>
          </li>
        )}
        <li>
          <Typography variant="body2">GLA is set to ±{glaPercentage}% of Subject</Typography>
        </li>
        <li>
          <Typography variant="body2">
            Site Size is set to ±{siteSizePercentage}% of Subject
          </Typography>
        </li>
      </ul>
    </Flex>
    <Button
      variant="inlineSecondary"
      icon="close"
      text=""
      size="sm"
      onClick={() => {
        dismissDefaultFiltersInfo(orderID);
        onDismiss();
      }}
    />
  </Flex>
);
